import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { piiProps } from 'src/components/DemoBlur';

const CustomFirstNameCell = ({ params }) =>
    <Typography variant="body2" align="center" textAlign='center' sx={{ fontWeight: 400, fontSize: '0.8125rem' }}>
        <span {...piiProps} style={{ textTransform: 'capitalize' }}>{params?.row?.first_name || ''}</span>
    </Typography>;

export default CustomFirstNameCell;

CustomFirstNameCell.propTypes = {
    params: PropTypes.any,
};
